/* eslint-disable no-unused-vars */
import React from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { clearGetState } from "../actionsMethods/masterMethods";

import back_img from "../assests/images/rightVector.svg";
const Heading = ({ title, navigateTo, id, navigateForward }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBack = () => {
    if (navigateTo) {
      navigate(navigateTo, { state: id });
    } else {
      if (title === "Client List") {
        localStorage.removeItem("clientId");
      }
      window.history.back();
      dispatch(clearGetState());
    }
  };

  // const goForward = () => {
  //   // console.log(navigateForward, "navigateTo");

  //   if (navigateForward) {
  //     navigate(navigateForward);
  //   }
  // };

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <p className="master-title-head">
          <img src={back_img} onClick={goBack} className="pointer" />
          <span>{title}</span>
        </p>
      </div>
      {/* <div>
        <p className="master-title-head">
          <span>{title}</span>
          <img src={back_img} onClick={goForward} className="pointer" />
        </p>
      </div> */}
    </div>
  );
};
export default Heading;
